export default {
    validate(value) {
        return `${value}`.match(/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/gi) && !Number.isNaN(Date.parse(value))
    }
}
